import { useOrganizationStore } from 'store/modules';

export default function (to, from, next) {
    const organizationStore = useOrganizationStore();

    const savedRepliesV2 = organizationStore.featureFlags?.saved_replies_v2;

    if (
        to.name === 'settings.personal.settings' &&
        to?.params?.tab === 'canned-messages' &&
        savedRepliesV2
    ) {
        next('/settings/saved-replies');
        return;
    }

    next();
}
